var exports = {
  "R": "xe564cbfb--bc7109--preloader",
  "t": "xe564cbfb--bc7109--spin",
};

module.exports = exports;
